import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProcessService {
  private apiUrl = `${environment.apiUrl}`;

  constructor(private http: HttpClient) {}

  sincronizarExpedientes(
    numeroIdentificacion: string,
    tipoIdentificacion: string,
    idTipoDocumento: number,
    idUsuario: number,
    idTipoUsuario: number,
    esManual?: boolean,
  ): Observable<any> {
    const url = esManual
      ? `${this.apiUrl}/expediente/sincronizar/${numeroIdentificacion}/${tipoIdentificacion}/${idTipoDocumento}/${idUsuario}/${idTipoUsuario}/true`
      : `${this.apiUrl}/expediente/sincronizar/${numeroIdentificacion}/${tipoIdentificacion}/${idTipoDocumento}/${idUsuario}/${idTipoUsuario}`;

    return this.http.get(url);
  }
}
